<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show">
                    <v-toolbar dark color="blue">
                        <v-toolbar-title class="my-0 py-0">Nuevo Objetivo</v-toolbar-title>
                    </v-toolbar>
                </v-card>
                <v-card color="blue lighten-4">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="2">
                                <v-text-field label="Año" dense v-model="periodo">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-select dense v-model="clave" :items="clavearea" label="Clave / Área" item-text="text"
                                    item-value="value"></v-select>
                            </v-col>
                            <v-col cols="6" sm="6" md="2">
                                <v-text-field label="N° de Objetivo" dense v-model="codgral">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="2">
                                <v-select dense v-model="asociado" :items="objasociado" label="Objetivo Asociado"
                                    item-text="text" item-value="value"></v-select>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-select dense v-model="tipo" :items="tipos" label="Tipo" item-text="text"
                                    item-value="value"></v-select>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="2">
                                <v-select dense v-model="proceso" :items="procesos" label="Proceso" item-text="proceso"
                                    item-value="codgral"></v-select>
                            </v-col>
                            <v-col cols="6" sm="8" md="2">
                                <v-text-field label="Subproceso" dense v-model="subproceso">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="4" md="1">
                                <v-btn class="mx-2" @click="botonSubproceso" dark small color="primary">
                                    <v-icon dark>
                                        mdi-arrow-left-bold
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="6" sm="8" md="7">
                                <v-select dense v-model="filtrosubproceso" :items="subprocesos" item-text="subproceso"
                                    item-value="codsubproceso"></v-select>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea label="Descripción de Objetivo" dense rows="2" auto-grow v-model="objetivo">
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea label="Meta" dense rows="2" auto-grow v-model="meta">
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="6">
                                <v-text-field label="Responsable" dense v-model="responsable">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="2">
                                <v-text-field label="Plazo" dense v-model="plazo">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="2">
                                <v-text-field label="Indicador" dense v-model="indicador">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="2">
                                <v-text-field label="Plan" dense v-model="plan">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea label="Valor Anterior" dense rows="2" auto-grow v-model="valorant">
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" sm="8" md="9">
                                <v-text-field label="Área" dense v-model="area">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="4" md="1">
                                <v-btn class="mx-2" @click="botonArea" dark small color="primary">
                                    <v-icon dark>
                                        mdi-arrow-left-bold
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="6" sm="8" md="2">
                                <v-select dense v-model="filtroarea" :items="areas" item-text="text"
                                    item-value="value"></v-select>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="4">
                                <v-select label="Sector" dense v-model="sector" :items="sectores" item-text="text"
                                    item-value="value"></v-select>
                            </v-col>
                            <v-col cols="6" sm="6" md="4">
                                <v-select label="Titulo" dense v-model="titulo" :items="titulos" item-text="titulo"
                                    item-value="titulo"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-card-text>
                        <v-data-table dense :headers="headers" :items="listado" locale="es-ar" height="300" fixed-header
                            :items-per-page="200" hide-default-footer class="pa-0 ma-0">
                            <template v-slot:item.descr="{ item }">
                                <v-text-field dense v-model="item.descr" class="font-class-name"></v-text-field>
                            </template>
                            <template v-slot:item.tipo="{ item }">
                                <v-select dense v-model="item.tipo" :items="tiposref" item-text="text"
                                    item-value="value" class="font-class-name"></v-select>
                            </template>
                            <template v-slot:item.condicion="{ item }">
                                <v-select dense v-model="item.condicion" :items="condiciones" item-text="text"
                                    item-value="value" class="font-class-name"></v-select>
                            </template>
                            <template v-slot:item.referencia="{ item }">
                                <v-text-field dense v-model="item.referencia" class="font-class-name"></v-text-field>
                            </template>

                        </v-data-table>
                        <v-btn dense class="mx-2" dark small color="yellow" @click="addRow()">Agregar
                            fila</v-btn>
                    </v-card-text>
                </v-card>

                <v-card color="blue" dark tile>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </div>
</template>

<script>
import { subtract } from "lodash";
import axios from "../../axios-auth";
import moment from "moment";
export default {
    data: (vm) => ({
        lazy: false,
        valid: false,
        codgral: "",
        periodo: moment().year(),
        clave: "",
        asociado: "",
        proceso: "",
        subproceso: "",
        objetivo: "",
        tipo: "",
        meta: "",
        responsable: "",
        plazo: "",
        indicador: "",
        valorant: "",
        plan: "",
        area: "",
        filtroarea: "",
        filtrosubproceso: "",
        sector: "",
        titulo: "",
        deshabilitar: false,
        clavearea: [{ value: "C", text: "Clave" },
        { value: "A", text: "De Área" },
        ],
        objasociado: [{ value: "201", text: "201" },
        { value: "202", text: "202" },
        { value: "203", text: "203" },
        { value: "204", text: "204" },
        { value: "205", text: "205" },
        ],
        tipos: [{ value: "E", text: "Estratégico" },
        { value: "O", text: "Operativo" },
        ],
        areas: [
            { value: "Administración", text: "Administración" },
            { value: "Abastecimiento", text: "Abastecimiento" },
            { value: "Depósito", text: "Depósito" },
            { value: "Personal y RRHH", text: "Personal y RRHH" },
            { value: "Control de Gestión", text: "Control de Gestión" },
            { value: "Sistemas", text: "Sistemas" },
            { value: "Comercial", text: "Comercial" },
            { value: "Ventas", text: "Ventas" },
            { value: "Marketing", text: "Marketing" },
            { value: "Secretaría Comercial", text: "Secretaría Comercial" },
            { value: "Ingeniería de Obra", text: "Ingeniería de Obra" },
            { value: "Obras y Servicios", text: "Obras y Servicios" },
            { value: "Ingeniería de Producto", text: "Ingeniería de Producto" },
            { value: "Fabricación", text: "Fabricación" },
            { value: "Sucursal Bs As", text: "Sucursal Bs As" },
            { value: "Técnica y Desarrollo", text: "Técnica y Desarrollo" },
            { value: "SSGG y Mantenimiento", text: "SSGG y Mantenimiento" },
            { value: "Gerencia del SGI", text: "Gerencia del SGI" },
            { value: "Inspección y Ensayo", text: "Inspección y Ensayo" },
            { value: "Higiene y Seguridad", text: "Higiene y Seguridad" },
            { value: "Medio Ambiente", text: "Medio Ambiente" },
            { value: "Medicina Laboral", text: "Medicina Laboral" },
            { value: "Brigadas", text: "Brigadas" }
        ],
        procesos: [],
        subprocesos: [],
        listado: [{ descr: "", tipo: "", condicion: "", referencia: "" },
        { descr: "", tipo: "", condicion: "", referencia: "" },
        { descr: "", tipo: "", condicion: "", referencia: "" },
        { descr: "", tipo: "", condicion: "", referencia: "" },
        { descr: "", tipo: "", condicion: "", referencia: "" },
        ],
        tiposref: [{ value: "CU", text: "Cumplimiento" },
        { value: "N", text: "Numérico" },
        { value: "P", text: "Porcentual" },
        { value: "I", text: "Indicador" },
        { value: "CA", text: "Capacitación" },
        { value: "DA", text: "Dato" },
        { value: "PL", text: "Plan" },
        ],
        condiciones: [{ value: "MA", text: "Mayor a la referencia" },
        { value: "ME", text: "Menor a la referencia" },
        { value: "IG", text: "Igual a la referencia" },
        ],
        sectores: [{ text: "Comercializ. / Cliente / Posventa", value: "Comercializ. / Cliente / Posventa" },
        { text: "Ingeniería / Fabricación / Obra / SSGG", value: "Ingeniería / Fabricación / Obra / SSGG" },
        { text: "Administr. y Finanzas", value: "Administr. y Finanzas" },
        { text: "Recursos Humanos", value: "Recursos Humanos" },
        { text: "Sistema de Gestión Integrado", value: "Sistema de Gestión Integrado" },
        { text: "Organización Interna", value: "Organización Interna" },
        ],
        titulos: [],
        headers: [{
            text: "Descripción de la Referencia",
            align: "start",
            sortable: false,
            value: "descr",
            width: "40%"
        },
        { text: "Tipo de Referencia", value: "tipo", sortable: false },
        { text: "Condición de Cumplimiento", value: "condicion", sortable: false },
        { text: "Valor de Referencia", value: "referencia", sortable: false },
        ],
        listadoref: [],
    }),
    computed: {
        show: {
            get() {
                this.cargarproceso();
                this.cargarsubproceso();
                this.cargartitulos();
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    methods: {

        cargarproceso() {
            let self = this;
            axios
                .get("/Indicadores/Cargarprocesos?")
                .then((response) => {
                    self.procesos = response.data;
                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },
        cargarsubproceso() {
            let self = this;
            axios
                .get("/Indicadores/Cargarsubprocesos?")
                .then((response) => {
                    self.subprocesos = response.data;
                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },

        cargartitulos() {
            let self = this;
            axios
                .get("/Indicadores/Cargartitulos?")
                .then((response) => {
                    self.titulos = response.data;
                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },
        addRow() {
            this.listado.push({ descr: "", tipo: "", condicion: "", referencia: "" },)
        },
        botonArea() {
            this.area = this.area + this.filtroarea + " - ";
        },
        botonSubproceso() {
            this.subproceso = this.subproceso + this.filtrosubproceso + " - ";
        },

        guardar() {
            this.$swal({
                title: "Guardar Objetivo",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    this.listado.forEach((element) => {
                        if (element.descr != "" && element.descr != null) {
                            this.listadoref.push({
                                codgral: this.codgral,
                                periodo: this.periodo,
                                descr: element.descr,
                                tipo: element.tipo,
                                condicion: element.condicion,
                                referencia: element.referencia,

                            });
                        }
                    });

                    var datos = {
                        periodo: this.periodo,
                        clave: this.clave,
                        codgral: this.codgral,
                        asociado: this.asociado,
                        proceso: this.proceso,
                        subproceso: this.subproceso,
                        tipo: this.tipo,
                        objetivo: this.objetivo,
                        meta: this.meta,
                        responsable: this.responsable,
                        plazo: this.plazo,
                        indicador: this.indicador,
                        plan: this.plan,
                        valorant: this.valorant,
                        area: this.area,
                        sector: this.sector,
                        titulo: this.titulo,
                        referencias: this.listadoref,
                    };
                    let self = this;
                    axios
                        .post("/Indicadores/GuardarObjetivos", datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();

                            self.showAlert({
                                icon: "success",
                                title: "Objetivo guardado con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
        vaciarModels() {
            this.codgral = "";
            this.periodo = "";
            this.objetivo = "";
            this.proceso = "";
            this.subproceso = "";
            this.meta = "";
            this.indicador = "";
            this.plan = "";
            this.area = "";
            this.asociado = "";
            this.tipo = "";
            this.clave = "";
            this.responsable = "";
            this.plazo = "";
            this.valorant = "";
            this.deshabilitar = false;
            this.sector = "";
            this.titulo = "";
            this.$router.push({ name: "MainAplicaciones" });
        },
    },
}
</script>